// src/components/UnpublishedProfile.js
import React from 'react';
import { Link } from 'react-router-dom';
import styles from './UnpublishedProfile.module.css';
import IconBackground from './IconBackground';

const UnpublishedProfile = ({ username }) => {
  return (
    <div className={styles.container}>
      {/* Use the same icon background as other pages for visual consistency */}
      <IconBackground />
      
      <div className={styles.contentWrapper}>
        <div className={styles.content}>
          <h1 className={styles.title}>
            <span className={styles.linkPart}>link</span>
            <span className={styles.istPart}>ist</span>
          </h1>
          
          <div className={styles.message}>
            <p className={styles.username}>{username}</p>
            
            <p className={styles.statusText}>hasn't published anything yet.</p>
          </div>
          
          <div className={styles.callToAction}>
            <p>Want to create your own profile?</p>
            <Link to="/" className={styles.createButton}>
              Get your free linkist.se profile
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnpublishedProfile;